import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "disable-button-list"
}
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = {
  key: 0,
  class: "warning-duplicate"
}
const _hoisted_4 = { class: "warning-text-wrap" }
const _hoisted_5 = { class: "duplicate-text" }
const _hoisted_6 = {
  key: 1,
  class: "warning-duplicate"
}
const _hoisted_7 = { class: "warning-text-wrap" }
const _hoisted_8 = { class: "duplicate-text" }
const _hoisted_9 = {
  key: 2,
  class: "warning-duplicate"
}
const _hoisted_10 = { class: "warning-text-wrap" }
const _hoisted_11 = { class: "duplicate-text" }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_14 = { class: "flex-shrink-0" }
const _hoisted_15 = { class: "font-12 m-0 mr-2 mt-1" }
const _hoisted_16 = { class: "flex-grow-1" }
const _hoisted_17 = { class: "small-multiselect-wrap" }
const _hoisted_18 = {
  key: 4,
  class: "shadowed-card bg-white mb-1"
}
const _hoisted_19 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_20 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_21 = { class: "sr-only" }
const _hoisted_22 = { class: "imaged-col pr-0" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "image-hover-icon d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-search-plus" })
], -1)
const _hoisted_24 = { class: "edit-control" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_26 = { class: "d-flex justify-content-between" }
const _hoisted_27 = { class: "flex-shrink-0" }
const _hoisted_28 = { class: "size mr-2" }
const _hoisted_29 = { class: "flex-grow-1 text-end" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-pencil-alt",
  title: "Rename"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-trash-alt",
  title: "Delete"
}, null, -1)
const _hoisted_32 = {
  key: 5,
  class: "shadowed-card bg-white mb-1"
}
const _hoisted_33 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_34 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_35 = { class: "sr-only" }
const _hoisted_36 = { class: "imaged-col pr-0" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "image-hover-icon d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-search-plus" })
], -1)
const _hoisted_38 = { class: "edit-control" }
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_40 = { class: "d-flex justify-content-between" }
const _hoisted_41 = { class: "flex-shrink-0" }
const _hoisted_42 = { class: "size mr-2" }
const _hoisted_43 = { class: "flex-grow-1 text-end" }
const _hoisted_44 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-pencil-alt",
  title: "Rename"
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-trash-alt",
  title: "Delete"
}, null, -1)
const _hoisted_46 = {
  key: 6,
  class: "shadowed-card bg-white mb-1"
}
const _hoisted_47 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_48 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_49 = { class: "sr-only" }
const _hoisted_50 = { class: "imaged-col pr-0" }
const _hoisted_51 = { class: "small-img-wrap" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "image-hover-icon d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-search-plus" })
], -1)
const _hoisted_53 = { class: "edit-control" }
const _hoisted_54 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_55 = { class: "d-flex justify-content-between" }
const _hoisted_56 = { class: "flex-shrink-0" }
const _hoisted_57 = { class: "size mr-2" }
const _hoisted_58 = { class: "flex-grow-1 text-end" }
const _hoisted_59 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-pencil-alt",
  title: "Rename"
}, null, -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-trash-alt",
  title: "Delete"
}, null, -1)
const _hoisted_61 = {
  key: 7,
  class: "shadowed-card bg-white mb-1"
}
const _hoisted_62 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_63 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_64 = { class: "sr-only" }
const _hoisted_65 = { class: "imaged-col pr-0" }
const _hoisted_66 = { class: "small-img-wrap" }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "image-hover-icon d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-search-plus" })
], -1)
const _hoisted_68 = { class: "edit-control" }
const _hoisted_69 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_70 = { class: "d-flex justify-content-between" }
const _hoisted_71 = { class: "flex-shrink-0" }
const _hoisted_72 = { class: "size mr-2" }
const _hoisted_73 = { class: "flex-grow-1 text-end" }
const _hoisted_74 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-pencil-alt",
  title: "Rename"
}, null, -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-trash-alt",
  title: "Delete"
}, null, -1)
const _hoisted_76 = {
  key: 8,
  class: "shadowed-card bg-white mb-1"
}
const _hoisted_77 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_78 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_79 = { class: "sr-only" }
const _hoisted_80 = { class: "imaged-col pr-0" }
const _hoisted_81 = { class: "small-img-wrap" }
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "image-hover-icon d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-search-plus" })
], -1)
const _hoisted_83 = { class: "edit-control" }
const _hoisted_84 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_85 = { class: "d-flex justify-content-between" }
const _hoisted_86 = { class: "flex-shrink-0" }
const _hoisted_87 = { class: "size mr-2" }
const _hoisted_88 = { class: "flex-grow-1 text-end" }
const _hoisted_89 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-pencil-alt",
  title: "Rename"
}, null, -1)
const _hoisted_90 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-trash-alt",
  title: "Delete"
}, null, -1)
const _hoisted_91 = {
  key: 9,
  class: "shadowed-card bg-white mb-1"
}
const _hoisted_92 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_93 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_94 = { class: "sr-only" }
const _hoisted_95 = { class: "imaged-col pr-0" }
const _hoisted_96 = { class: "small-img-wrap" }
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "image-hover-icon d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-search-plus" })
], -1)
const _hoisted_98 = { class: "edit-control" }
const _hoisted_99 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_100 = { class: "d-flex justify-content-between" }
const _hoisted_101 = { class: "flex-shrink-0" }
const _hoisted_102 = { class: "size mr-2" }
const _hoisted_103 = { class: "flex-grow-1 text-end" }
const _hoisted_104 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-pencil-alt",
  title: "Rename"
}, null, -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-trash-alt",
  title: "Delete"
}, null, -1)
const _hoisted_106 = {
  key: 10,
  class: "shadowed-card bg-white mb-1"
}
const _hoisted_107 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_108 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_109 = { class: "sr-only" }
const _hoisted_110 = { class: "imaged-col pr-0" }
const _hoisted_111 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("div", { class: "image-hover-icon d-flex align-items-center justify-content-center" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-search-plus" })
  ]),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_112 = { class: "edit-control" }
const _hoisted_113 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-check",
  title: "Edit"
}, null, -1)
const _hoisted_114 = { class: "d-flex justify-content-between" }
const _hoisted_115 = { class: "flex-shrink-0" }
const _hoisted_116 = { class: "size mr-2" }
const _hoisted_117 = { class: "flex-grow-1 text-end" }
const _hoisted_118 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-pencil-alt",
  title: "Rename"
}, null, -1)
const _hoisted_119 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-trash-alt",
  title: "Delete"
}, null, -1)
const _hoisted_120 = {
  key: 11,
  class: "media-wrap shadowed-card bg-white mb-1"
}
const _hoisted_121 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_122 = { class: "centered-wrap" }
const _hoisted_123 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_124 = { class: "sr-only" }
const _hoisted_125 = { class: "edit-control" }
const _hoisted_126 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-check",
  title: "Edit"
}, null, -1)
const _hoisted_127 = { class: "d-flex justify-content-between" }
const _hoisted_128 = { class: "flex-shrink-0" }
const _hoisted_129 = { class: "size mr-2" }
const _hoisted_130 = { class: "flex-grow-1 text-end" }
const _hoisted_131 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-pencil-alt",
  title: "Rename"
}, null, -1)
const _hoisted_132 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-trash-alt",
  title: "Delete"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", {
    class: _ctx.dataFrom == 'chatChannel' ? 'image-in-chat mt-0 preview-image-list' : ''
  }, [
    (_ctx.disabledFileTagList && _ctx.disabledFileTagList.length)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('disabled_tags')), 1),
          _createVNode("ul", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.disabledFileTagList, (tag, tagIndex) => {
              return (_openBlock(), _createBlock("li", { key: tagIndex }, [
                _createTextVNode(_toDisplayString(tag.name) + " " + _toDisplayString(_ctx.$t('is_disabled_to_enable_click')) + " ", 1),
                _createVNode("a", {
                  href: "javascript:void(0)",
                  onClick: ($event: any) => (_ctx.enableSelectedFileTag(tag))
                }, _toDisplayString(tag.inProgress ? _ctx.$t('loading1') : _ctx.$t('enable')), 9, ["onClick"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('button')) + ". ", 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: _ctx.dataFrom !== 'chatChannel' ? 'row mx-n2 mb-2' : ''
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.imagesToUpload, (image, imageIndex) => {
        return (_openBlock(), _createBlock("div", {
          class: _ctx.dataClass,
          key: imageIndex
        }, [
          (!image.isvalidToUpload && image.duplicateFile)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t('duplicate_file_warning')), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.$t('file_size_large')) + ".", 1),
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('size_limit')) + ": 25MB ", 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!image.isvalidToUpload && !image.duplicateFile)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t('file_size_large')) + ".", 1),
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('size_limit')) + ": 25MB ", 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.isvalidToUpload && image.duplicateFile)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t('duplicate_file_warning')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dataFrom != 'docusignDocumentUpload')
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('file_tags')), 1)
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode(_component_Multiselect, {
                        modelValue: image.tag,
                        "onUpdate:modelValue": ($event: any) => (image.tag = $event),
                        mode: "tags",
                        options: _ctx.masterTags,
                        searchable: true,
                        createTag: true,
                        "close-on-select": true,
                        minChars: 2,
                        onTag: _ctx.addTag
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onTag"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
          image.extension === 'jpg' ||
          image.extension === 'png' ||
          image.extension === 'jpeg' ||
          image.extension === 'gif' ||
          image.extension === 'webp' ||
          image.extension === 'heic'
        )
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                (image.isuploded && image.isvalidToUpload)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      _createVNode("span", _hoisted_20, [
                        _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('loading1')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", {
                    class: "small-img-wrap",
                    onClick: ($event: any) => (_ctx.openLightbox(image,imageIndex))
                  }, [
                    _hoisted_23,
                    (image.extension === 'heic')
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/icons8-heic-48.png`
                : 'img/icons8-heic-48.png'
                ,
                          alt: "",
                          height: "200"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          src: image.base64,
                          alt: "",
                          height: "200"
                        }, null, 8, ["src"]))
                  ], 8, ["onClick"]),
                  _createVNode("h5", null, [
                    (!image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          title: image.fileName + '\nclick to rename',
                          onClick: ($event: any) => (_ctx.renameUploadImage(image))
                        }, _toDisplayString(_ctx.shortenedFileName(image.fileName)), 9, ["title", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_24, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.fileName = $event),
                          id: "user-name",
                          type: "text",
                          class: "form-control bg-light",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.fileName]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_25
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", _hoisted_27, [
                      _createVNode("p", _hoisted_28, _toDisplayString(image.size), 1)
                    ]),
                    _createVNode("div", _hoisted_29, [
                      (!image.isEdit)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "create-url mr-2",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.renameUploadImage(image))
                          }, [
                            _hoisted_30
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("a", {
                        class: "create-url",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_31
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.extension === 'pdf')
            ? (_openBlock(), _createBlock("div", _hoisted_32, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_33, [
                      _createVNode("span", _hoisted_34, [
                        _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('loading1')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_36, [
                  _createVNode("div", {
                    class: "small-img-wrap",
                    onClick: ($event: any) => (_ctx.openLightbox(image,imageIndex))
                  }, [
                    _hoisted_37,
                    _createVNode("img", {
                      src: _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/pdf.png`
                : 'img/pdf.png'
                ,
                      alt: ""
                    }, null, 8, ["src"])
                  ], 8, ["onClick"]),
                  _createVNode("h5", null, [
                    (!image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          title: image.fileName + '\nclick to rename',
                          onClick: ($event: any) => (_ctx.renameUploadImage(image))
                        }, _toDisplayString(_ctx.shortenedFileName(image.fileName)), 9, ["title", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_38, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.fileName = $event),
                          id: "user-name",
                          type: "text",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          class: "field-value form-control",
                          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.fileName]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_39
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_40, [
                    _createVNode("div", _hoisted_41, [
                      _createVNode("p", _hoisted_42, _toDisplayString(image.size), 1)
                    ]),
                    _createVNode("div", _hoisted_43, [
                      (!image.isEdit)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "create-url mr-2",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.renameUploadImage(image))
                          }, [
                            _hoisted_44
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("a", {
                        class: "create-url",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_45
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.extension === 'xls' || image.extension === 'xlsx' || image.extension === 'xlsm'
          || image.extension === 'xlsb' || image.extension === 'xltx')
            ? (_openBlock(), _createBlock("div", _hoisted_46, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_47, [
                      _createVNode("span", _hoisted_48, [
                        _createVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('loading1')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_50, [
                  _createVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createVNode("img", {
                      src: _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/excel.png`
                : 'img/excel.png'
                ,
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("h5", null, [
                    (!image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          title: image.fileName + '\nclick to rename',
                          onClick: ($event: any) => (_ctx.renameUploadImage(image))
                        }, _toDisplayString(_ctx.shortenedFileName(image.fileName)), 9, ["title", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_53, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.fileName = $event),
                          id: "user-name",
                          type: "text",
                          class: "form-control bg-light",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.fileName]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_54
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_55, [
                    _createVNode("div", _hoisted_56, [
                      _createVNode("p", _hoisted_57, _toDisplayString(image.size), 1)
                    ]),
                    _createVNode("div", _hoisted_58, [
                      (!image.isEdit)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "create-url mr-2",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.renameUploadImage(image))
                          }, [
                            _hoisted_59
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("a", {
                        class: "create-url",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_60
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.extension === 'ppt' || image.extension === 'pptm' || image.extension === 'pptx')
            ? (_openBlock(), _createBlock("div", _hoisted_61, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_62, [
                      _createVNode("span", _hoisted_63, [
                        _createVNode("span", _hoisted_64, _toDisplayString(_ctx.$t('loading1')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_65, [
                  _createVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createVNode("img", {
                      src: _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/ppt.png`
                : 'img/ppt.png'
                ,
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("h5", null, [
                    (!image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          title: image.fileName + '\nclick to rename',
                          onClick: ($event: any) => (_ctx.renameUploadImage(image))
                        }, _toDisplayString(_ctx.shortenedFileName(image.fileName)), 9, ["title", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_68, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.fileName = $event),
                          id: "user-name",
                          type: "text",
                          class: "form-control bg-light",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.fileName]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_69
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_70, [
                    _createVNode("div", _hoisted_71, [
                      _createVNode("p", _hoisted_72, _toDisplayString(image.size), 1)
                    ]),
                    _createVNode("div", _hoisted_73, [
                      (!image.isEdit)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "create-url mr-2",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.renameUploadImage(image))
                          }, [
                            _hoisted_74
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("a", {
                        class: "create-url",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_75
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.extension === 'csv')
            ? (_openBlock(), _createBlock("div", _hoisted_76, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_77, [
                      _createVNode("span", _hoisted_78, [
                        _createVNode("span", _hoisted_79, _toDisplayString(_ctx.$t('loading1')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_80, [
                  _createVNode("div", _hoisted_81, [
                    _hoisted_82,
                    _createVNode("img", {
                      src: _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/csv.png`
                : 'img/csv.png'
                ,
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("h5", null, [
                    (!image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          title: image.fileName + '\nclick to rename',
                          onClick: ($event: any) => (_ctx.renameUploadImage(image))
                        }, _toDisplayString(_ctx.shortenedFileName(image.fileName)), 9, ["title", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_83, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.fileName = $event),
                          id: "user-name",
                          type: "text",
                          class: "form-control bg-light",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.fileName]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_84
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_85, [
                    _createVNode("div", _hoisted_86, [
                      _createVNode("p", _hoisted_87, _toDisplayString(image.size), 1)
                    ]),
                    _createVNode("div", _hoisted_88, [
                      (!image.isEdit)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "create-url mr-2",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.renameUploadImage(image))
                          }, [
                            _hoisted_89
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("a", {
                        class: "create-url",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_90
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.extension === 'zip' || image.extension === 'rar' || image.extension === 'tar')
            ? (_openBlock(), _createBlock("div", _hoisted_91, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_92, [
                      _createVNode("span", _hoisted_93, [
                        _createVNode("span", _hoisted_94, _toDisplayString(_ctx.$t('loading1')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_95, [
                  _createVNode("div", _hoisted_96, [
                    _hoisted_97,
                    _createVNode("img", {
                      src: _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/file.jpg`
                : 'img/file.jpg'
                ,
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("h5", null, [
                    (!image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          title: image.fileName + '\nclick to rename',
                          onClick: ($event: any) => (_ctx.renameUploadImage(image))
                        }, _toDisplayString(_ctx.shortenedFileName(image.fileName)), 9, ["title", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_98, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.fileName = $event),
                          id: "user-name",
                          type: "text",
                          class: "form-control bg-light",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.fileName]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_99
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_100, [
                    _createVNode("div", _hoisted_101, [
                      _createVNode("p", _hoisted_102, _toDisplayString(image.size), 1)
                    ]),
                    _createVNode("div", _hoisted_103, [
                      (!image.isEdit)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "create-url mr-2",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.renameUploadImage(image))
                          }, [
                            _hoisted_104
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("a", {
                        class: "create-url",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_105
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.extension === 'doc' || image.extension === 'docx')
            ? (_openBlock(), _createBlock("div", _hoisted_106, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_107, [
                      _createVNode("span", _hoisted_108, [
                        _createVNode("span", _hoisted_109, _toDisplayString(_ctx.$t('loading1')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_110, [
                  _hoisted_111,
                  (!image.isEdit)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        title: _ctx.$t('click_to_rename'),
                        onClick: ($event: any) => (_ctx.renameUploadImage(image))
                      }, [
                        _createVNode("h5", null, _toDisplayString(image.fileName), 1)
                      ], 8, ["title", "onClick"]))
                    : _createCommentVNode("", true),
                  (image.isEdit)
                    ? _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": ($event: any) => (image.fileName = $event),
                        id: "user-name",
                        type: "text",
                        onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                        class: "field-value form-control",
                        onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                      }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                        [_vModelText, image.fileName]
                      ])
                    : _createCommentVNode("", true),
                  _createVNode("h5", null, [
                    (!image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          title: image.fileName + '\nclick to rename',
                          onClick: ($event: any) => (_ctx.renameUploadImage(image))
                        }, _toDisplayString(_ctx.shortenedFileName(image.fileName)), 9, ["title", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_112, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.fileName = $event),
                          id: "user-name",
                          type: "text",
                          class: "form-control bg-light",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.fileName]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_113
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_114, [
                    _createVNode("div", _hoisted_115, [
                      _createVNode("p", _hoisted_116, _toDisplayString(image.size), 1)
                    ]),
                    _createVNode("div", _hoisted_117, [
                      (!image.isEdit)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "create-url mr-2",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.renameUploadImage(image))
                          }, [
                            _hoisted_118
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("a", {
                        class: "create-url",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_119
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
          image.extension === 'mp4' ||
          image.extension === 'mov' ||
          image.extension === 'MOV' ||
          image.extension === 'wmv' ||
          image.extension === 'webm' ||
          image.extension === 'ogg' ||
          image.extension === 'avi' ||
          image.extension === 'x-ms-wmv'
        )
            ? (_openBlock(), _createBlock("div", _hoisted_120, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_121, [
                      _createVNode("div", _hoisted_122, [
                        _createVNode("span", _hoisted_123, [
                          _createVNode("span", _hoisted_124, _toDisplayString(_ctx.$t('loading1')), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("img", {
                  src: _ctx.state.data.imageBaseUrl
            ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
            : 'img/video-icon.png'
            ,
                  alt: "",
                  height: "200"
                }, null, 8, ["src"]),
                _createVNode("h5", null, [
                  (!image.isEdit)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        title: image.fileName + '\nclick to rename',
                        onClick: ($event: any) => (_ctx.renameUploadImage(image))
                      }, _toDisplayString(_ctx.shortenedFileName(image.fileName)), 9, ["title", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_125, [
                  (image.isEdit)
                    ? _withDirectives((_openBlock(), _createBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": ($event: any) => (image.fileName = $event),
                        id: "user-name",
                        type: "text",
                        class: "form-control bg-light",
                        onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                        onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                      }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                        [_vModelText, image.fileName]
                      ])
                    : _createCommentVNode("", true),
                  (image.isEdit)
                    ? (_openBlock(), _createBlock("a", {
                        key: 1,
                        class: "save-icon",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                      }, [
                        _hoisted_126
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_127, [
                  _createVNode("div", _hoisted_128, [
                    _createVNode("p", _hoisted_129, _toDisplayString(image.size), 1)
                  ]),
                  _createVNode("div", _hoisted_130, [
                    (!image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          class: "create-url mr-2",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImage(image))
                        }, [
                          _hoisted_131
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode("a", {
                      class: "create-url",
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                    }, [
                      _hoisted_132
                    ], 8, ["onClick"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ], 2)
  ], 2))
}